export default __webpack_public_path__ + "static/media/image 5-1.83048699.png";